import React from 'react';

import { Field } from 'react-final-form';

import { Switch } from 'components/ui';

const FormSmallSwitch = ({ name, disabled, onChange = null, readOnly = false }) => {
  return (
    <Field name={name}>
      {({ input, meta }) => (
        <Switch
          checked={!!input.value}
          disabled={disabled}
          onChange={(e) => {
            if (readOnly) {
              return
            }
            
            input.onChange(e.target.checked);
            onChange && onChange(e.target.checked)
          }}
        />
      )}
    </Field>
  );
};

export default FormSmallSwitch;
